<template>
  <div class="lsx-news">
    <div class="lsx-news-title mb-2">
      <strong>ເປີດເຜີຍຂໍ້ມູນ</strong>
    </div>
    <ul>
      <li>
        <span><a href="#" target="_blank">ມະຕິກອງປະຊຸມວິສາມັນ ສະພາບໍລິຫານຂອງບໍລິສັດ ວຽງຈັນເຊັນເຕີ ລາວ ມະຫາຊົນ ຄັ້ງທີ 4 ປະຈຳປີ 2023</a></span>
      </li>
      <li>
        <span><a href="#" target="_blank">ເຊີນເຂົ້າຮ່ວມກອງປະຊຸມວິສາມັນຜູ້ຖືຮຸ້ນ ຄັ້ງທີ 2 ປະຈຳປີ 2023.</a></span>
      </li>
      <li>
        <span><a href="#" target="_blank">ມະຕິກອງປະຊຸມສາມັນ ສະພາບໍລິຫານ ບໍລິສັດ ວຽງຈັນເຊັນເຕີ ລາວ ມະຫາຊົນ ຄັ້ງທີ 4 ປະຈຳປີ 2023</a></span>
      </li>
      <li>
        <span><a href="#" target="_blank">ມະຕິທີ່ສໍາຄັນຂອງກອງປະຊຸມສະພາບໍລິຫານ ຄັ້ງທີ 5 ປີ 2023</a></span>
      </li>
      <li>
        <span><a href="#" target="_blank">ບົດລາຍງານສະຖິຕິການເງິນແຫ່ງລັດ ປະຈໍາປີ 2022</a></span>
      </li>
      <li>
        <span><a href="#" target="_blank">ບົດລາຍງານການດຳເນີນທຸລະກິດ 06 ເດືອນຕົ້ນປີ 2023 ຂອງບໍລິສັດ ຊີມັງລາວ ມະຫາຊົນ</a></span>
      </li>
      <li>
        <span><a href="#" target="_blank">ເອກະສານລາຍງານການເງິນສໍາລັບໄລຍະຫົກເດືອນຕົ້ນປີທີ່ສິ້ນສຸດວັນທີ 30 ມິຖຸນາ 2023</a></span>
      </li>
      <li>
        <span><a href="#" target="_blank">ເອກະສານລາຍງານການເງິນກາງປີແບບສັງລວມ ແລະ ແບບແຍກກິດຈະການ ສຳລັບໄລຍະຫົກເດືອນຕົ້ນປີສີ້ນສຸດວັນທີ 30 ມິຖຸນາ 2023</a></span>
      </li>
      <li>
        <span><a href="#" target="_blank">The First Six-Month Period of 2023. 30 June 2023.</a></span>
      </li>
      <li>
        <span><a href="#" target="_blank">ບົດລາຍງສນການເງິນປະຈຳ 6 ເດືອນຕົ້ນປີ 2023</a></span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'LSXNews'
}
</script>
<style lang="scss" scoped>
.lsx-news {
  .lsx-news-title {
    border-bottom: 3px double red;
  }

  ul {
    padding: 0;

    li {
      padding: 5px 0;
      margin: 0;
      list-style: none;
      display: flex;
      justify-content: space-between;
      font-size: 90%;
      border-bottom: 1px dotted #999999;

      a {
        color: #666666;
        white-space-collapse: collapse;
        text-wrap: nowrap;
        display: block;
        width: 500px;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      a:hover {
        color: #9C0225;
      }

      .news-date {
        font-size: 90%;
        margin-left: 10px;
      }

      .badge {
        font-weight: normal;
        padding: 2px 12px;
        border-radius: 8px;
      }
    }
  }
}
</style>
